import React, { useState } from "react";
//outsource
import { Button, message } from "antd";
import DialogIncomeStaffEdit from "../../dialog/dialog_income_staff_edit";
import { useDispatch, useSelector } from "react-redux";
import { allSelector } from "../../../../store/job/job.selector";
import { lockJobById, updateJobById } from "../../../../store/job/job.action";
import moment from "moment";
import lodash from "lodash";

//components

const InputIncome = ({ data, edit }) => {
  // -------------------------- VAR --------------------------
  const number = data?.value || 0;
  // console.log({ data });
  // -------------------------- STATE --------------------------
  const [openEdit, setOpenEdit] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const jobList = useSelector(allSelector);

  const selectedJob = jobList?.find((job) => job?.id === data?.jobId);
  const totalIncome = lodash.sumBy(selectedJob?.staffs, (item) => item?.value);
  const overIncome = totalIncome > selectedJob?.subtotal;
  // -------------------------- FUNCTION --------------------------
  const handleClick = () => {
    const id = data?.jobId;
    if (id) {
      dispatch(
        lockJobById({ id }, (res) => {
          if (res.status === 200) {
            console.log("locked");
            setOpenEdit(true);
          } else {
            message.warning(
              "Someone is entering income for this job. Please choose again later."
            );
          }
        })
      );
    } else {
      setOpenEdit(true);
    }
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <>
      <Button
        disabled={!edit}
        style={{ width: "100%", color: "black" }}
        onClick={handleClick}
        danger = {overIncome}
      >
        {number}
      </Button>
      <DialogIncomeStaffEdit
        open={openEdit}
        setOpen={setOpenEdit}
        data={data}
      />
    </>
  );
};

export default InputIncome;
